export default "__VITE_ASSET__Ctcuy679__"